/**
 * Ashore API
 * Hand-written client for the customer-portal endpoints, following the
 * generated OpenAPI client conventions (see ApproverGroupApi.js).
 */

import ApiClient from "../ApiClient";

/**
* Portal service.
* @module api/PortalApi
* @version V1
*/
export default class PortalApi {

    /**
    * Constructs a new PortalApi.
    * @alias module:api/PortalApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Branding info for the portal login page. Anonymous.
     * @param {String} accountPublicId
     */
    getAccountInfo(accountPublicId, callback) {
      let postBody = null;
      if (accountPublicId === undefined || accountPublicId === null) {
        throw new Error("Missing the required parameter 'accountPublicId' when calling getAccountInfo");
      }

      let pathParams = {
        'accountPublicId': accountPublicId
      };
      let queryParams = {};
      let headerParams = {};
      let formParams = {};

      let authNames = [];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/portal/{accountPublicId}/info', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Request a magic sign-in link. Always returns 200. Anonymous.
     * @param {String} accountPublicId
     * @param {Object} opts Optional parameters
     * @param {Object} [opts.portalMagicLinkRequest] {email}
     */
    requestMagicLink(accountPublicId, opts, callback) {
      opts = opts || {};
      let postBody = opts['portalMagicLinkRequest'];
      if (accountPublicId === undefined || accountPublicId === null) {
        throw new Error("Missing the required parameter 'accountPublicId' when calling requestMagicLink");
      }

      let pathParams = {
        'accountPublicId': accountPublicId
      };
      let queryParams = {};
      let headerParams = {};
      let formParams = {};

      let authNames = [];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/portal/{accountPublicId}/magic-link', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Consume a magic-link token and receive a portal session. Anonymous.
     * @param {String} magicToken
     */
    exchangeSession(magicToken, callback) {
      let postBody = null;
      if (magicToken === undefined || magicToken === null) {
        throw new Error("Missing the required parameter 'magicToken' when calling exchangeSession");
      }

      let pathParams = {
        'magicToken': magicToken
      };
      let queryParams = {};
      let headerParams = {};
      let formParams = {};

      let authNames = [];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/portal/session/{magicToken}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * All proofs for the signed-in approver's email. Requires a portal session token.
     */
    getProofs(callback) {
      let postBody = null;

      let pathParams = {};
      let queryParams = {};
      let headerParams = {};
      let formParams = {};

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = [Object];
      return this.apiClient.callApi(
        '/portal/proofs', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }
}
